import ApiService from '@/data/services/ApiService'
import { AxiosResponse } from 'axios'
import { IPaginatedServiceResponse, IServiceResponse } from '@/data/models/ServiceResponse'

export class MatchRolesApiService extends ApiService {
  static async getPlayerRoles(query: object): Promise<IPaginatedServiceResponse<object>> {
    return this.axios.get('player-match-roles', { params: query })
      .then((response: AxiosResponse<IPaginatedServiceResponse<object>>) => response.data)
  }

  static async getCoachRoles(query: object): Promise<IServiceResponse<object>> {
    return this.axios.get('coach-match-roles', { params: query })
      .then((response: AxiosResponse<IServiceResponse<object>>) => response.data)
  }
}
